import { render } from "./ChatMessageToolbar.vue?vue&type=template&id=f619f6b0"
import script from "./ChatMessageToolbar.vue?vue&type=script&lang=js"
export * from "./ChatMessageToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__